import { useContext } from "react";
import { ConfigurationContext } from "../providers/ConfigurationProvider";
import { PolicyConfig } from "../types";

const useConfigurationProvider = (): PolicyConfig => {
  const context = useContext(ConfigurationContext);
  if (context === undefined) {
    throw new Error(
      "useConfigurationProvider must be used within a ConfigurationProvider",
    );
  }
  return context;
};

export default useConfigurationProvider;
